export const ids = {
  catalog: {
    locationFilter: 'location-filter',
    radiusFilter: 'radius-filter',
    datesFilter: 'dates-filter',
  },
};
